var styles = {
  "Title": "_Title_gk0ma_1"
};

export { styles as default };
